export const SSO_SESSION_TOKEN_KEY = 'sis_customer_sso_token';

export const canUseClientStorage = () => {
  return process.client && typeof window !== 'undefined' && typeof sessionStorage !== 'undefined';
}

export const getStoredSsoSessionToken = () => {
  if (!canUseClientStorage()) return null;
  return sessionStorage.getItem(SSO_SESSION_TOKEN_KEY);
}

export const setStoredSsoSessionToken = (token) => {
  if (!canUseClientStorage() || !token) return;
  sessionStorage.setItem(SSO_SESSION_TOKEN_KEY, token);
}

export const clearStoredSsoSessionToken = () => {
  if (!canUseClientStorage()) return;
  sessionStorage.removeItem(SSO_SESSION_TOKEN_KEY);
}

export const buildSsoAuthorizationHeaders = (token = getStoredSsoSessionToken()) => {
  if (!token) return {};
  return { Authorization: token.startsWith('Bearer ') ? token : 'Bearer ' + token };
}
